import { SortOrder } from "antd/es/table/interface";
import { GetTokenFromCookie } from "../API/api";

export const generateStatusColorMap = (
  data: { statusId: number; status: string; statusColour: string }[]
) => {
  const statusColorObject = data.reduce((acc: any, item) => {
    acc[item.status] = item.statusColour;
    return acc;
  }, {});
  localStorage.setItem("statusColors", JSON.stringify(statusColorObject));
};

export const customSortDirections: SortOrder[] = [
  "ascend",
  "descend",
  "ascend",
];

export const getCookieToken = async () => {
  try {
    const response = await GetTokenFromCookie();
    const responseToken = response?.data?.AccessToken;
    return responseToken;
  } catch (error) {
    console.error("Error fetching token:", error);
    return;
  }
};
